import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from './../../../../themes/default';
import { Buttons } from './../../../../components/includes/container';
import { Btn } from './../../../../components/includes/ui';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    background: theme.palette.grey[100],
    border: `1px solid ${ theme.palette.grey[200] }`
  }
});

class ComponentToolbar extends React.Component {
  /*
  ** @Submit
  ** @Description: Delete component
  */

  handleDelete = (id) => {
    //console.log(id);
    this.props.Delete(id);
  }

  render(){

    const { classes, component } = this.props;

    return(
      <div className={ classes.root }>
        <Buttons align="right">
          <Btn color="primary" size="xsmall" variant="contained">Editar</Btn>
          <Btn color="danger" size="xsmall" variant="contained" onClick={ ()=>{ this.handleDelete(component._id) } }>Eliminar</Btn>
        </Buttons>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    alert: state.Alert,
    components: state.ComponentsUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Delete: (data) => {
      dispatch({
        type: 'COMPONENT_DELETE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ComponentToolbar));
